module.exports = __webpack_public_path__ + "../assets/img/8647c92e7e99b21fbdb1485b1ce80d69.svg";